import sharedModule from '../../shared.module';

class ScriptUtil {
    constructor($q, $window) {
        this.$q = $q;
        this.$window = $window;

        this.scripts = {};
    }

    loadScripts(urls) {
        var promises = urls.reduce((array, url) => {
            array.push(this.loadScript(url));
            return array;
        }, []);

        return this.$q.all(promises);
    }

    loadScript(url) {
        if (this.scripts[url] && this.scripts[url].loaded) {
            return this.$q.resolve(this.scripts[url]);
        }

        var script = this.$window.document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;

        var deferred = this.$q.defer();

        script.onload = () => {
            this.scripts[url] = {
                loaded: true,
                src: url
            };
            deferred.resolve(this.scripts[url]);
        };

        script.onerror = () => {
            deferred.reject();
        };

        this.$window.document
            .getElementsByTagName('head')[0]
            .appendChild(script);

        return deferred.promise;
    }
}

export default sharedModule.service('scriptUtil', ScriptUtil);



// WEBPACK FOOTER //
// ./modules/shared/services/scriptUtil/scriptUtil.service.js